import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "morfeusz:lang";

const readInitialLang = () => {
  if (typeof window === "undefined") return "pl";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "pl" || stored === "en") return stored;
  } catch (_) {
    /* ignore */
  }
  // Browser language fallback
  if (typeof navigator !== "undefined") {
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("en")) return "en";
  }
  return "pl";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(readInitialLang);

  const setLang = (next) => {
    if (next !== "pl" && next !== "en") return;
    setLangState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (_) {
      /* ignore */
    }
  };

  // Mirror the lang attribute on <html>
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.pl,
    }),
    [lang],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      lang: "pl",
      setLang: () => {},
      t: translations.pl,
    };
  }
  return ctx;
};
